import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Auth from '@iso/redux/auth/reducer';
import AccountBoard from '@iso/redux/accountBoard/reducer';
import AccountWizard from '@iso/redux/accountWizard/reducer';
import ProducerJob from '@iso/redux/producerJob/reducer';
import ContractorJob from '@iso/redux/contractorJob/reducer';
import User from '@iso/redux/user/reducer';
import Notification from '@iso/redux/notification/reducer';
import Company from '@iso/redux/company/reducer';
import Location from '@iso/redux/location/reducer';
import Modal from '@iso/redux/modal/reducer';
import JobBid from '@iso/redux/jobBid/reducer';
import JobDocument from '@iso/redux/jobDocument/reducer';
import JobAgency from '@iso/redux/jobAgency/reducer';
import JobInvoice from '@iso/redux/jobInvoice/reducer';
import PersonalNetwork from '@iso/redux/personalNetwork/reducer';
import CompanyNetwork from '@iso/redux/companyNetwork/reducer';
import ContractorInvoice from '@iso/redux/contractorInvoice/reducer';
import CompanyDocument from '@iso/redux/companyDocument/reducer';
import Wallet from '@iso/redux/wallet/reducer';
import UserIntro from '@iso/redux/intro/reducer';
import ContactImport from '@iso/redux/contactImport/reducer';
import RemoteConfiguration from '@iso/redux/remoteConfiguration/reducer';
import PayByInvitation from '@iso/redux/payByInvitation/reducer';
import BuddiBot from '@iso/redux/buddibot/reducer';
import { SIGNOUT } from "@iso/redux/auth/constants";

const appReducer = combineReducers({
  Auth,
  AccountBoard,
  AccountWizard,
  ProducerJob,
  ContractorJob,
  App,
  User,
  Company,
  Notification,
  Modal,
  Location,
  JobBid,
  JobDocument,
  JobAgency,
  JobInvoice,
  PersonalNetwork,
  CompanyNetwork,
  ContractorInvoice,
  CompanyDocument,
  Wallet,
  UserIntro,
  ContactImport,
  RemoteConfiguration,
  PayByInvitation,
  BuddiBot
});

// set all the state to initial state
const rootReducer = (state, action) => {
  if (action.type === SIGNOUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
